/**
 * Reports whether a keydown is the Flora "new chat" shortcut, ⌘⇧O (Ctrl+Shift+O
 * off macOS). Matches the full-page Flora handler so both surfaces respond to
 * the same keys.
 *
 * @param {Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'shiftKey'>} event - The keydown to test
 * @returns {boolean} True when the event is the new-chat shortcut
 */
const isNewChatShortcut = (event: Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'shiftKey'>): boolean =>
  (event.metaKey || event.ctrlKey) && event.shiftKey && event.key.toLowerCase() === 'o';

/**
 * Returns the platform-appropriate label for the new-chat shortcut, in the
 * same notation as the full-page sidebar.
 *
 * @param {string} platform - Typically `navigator.platform`
 * @returns {string} `⌘⇧O` on Apple platforms, `Ctrl⇧O` elsewhere
 */
const getNewChatShortcutLabel = (platform: string): string => (/Mac|iPhone|iPad/.test(platform) ? '⌘⇧O' : 'Ctrl⇧O');

export { getNewChatShortcutLabel, isNewChatShortcut };
